import { render, staticRenderFns } from "./myDetailUse.vue?vue&type=template&id=bbd8a608&scoped=true"
import script from "./myDetailUse.vue?vue&type=script&lang=js"
export * from "./myDetailUse.vue?vue&type=script&lang=js"
import style0 from "./myDetailUse.vue?vue&type=style&index=0&id=bbd8a608&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbd8a608",
  null
  
)

export default component.exports